import {createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash/isEqual';
import CONSTANTS from './constants';

const {NAME} = CONSTANTS;

const getAllTables = (state) => state[NAME];
const getQuestionTable = ({state, questionId}) => {
  const tables = getAllTables(state);
  return tables[questionId];
};


export const getTableForQuestion = createSelector(
	[getQuestionTable],
	(table) => {
		//console.log('getTableForQuestion: ', table);
	  return table;
	}
);

export const makeGetTableForQuestion = () => {
  return getTableForQuestion;
};

export const getQuestionTableFilters = createSelector(
	[getTableForQuestion],
	(table) => {
	  if (table) {
		return table.filters;
	  }

	  return [];
	}
);


// WEBPACK FOOTER //
// ./components/qual/Table/ducks/selectors.js